import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import wolfpackLogo from "../../../commom/Assets/images/LogoNew.png";
import depositBonusImg from '../../../style/images/more_spin_bg.png';
import coinIcon from '../../../style/images/coin-icon.png';

interface DepositTier {
    minAmount: number;
    spinCount: number;
}

interface DepositBonusPopupProps {
    open: boolean;
    onClose: () => void;
    onFundNow: () => void;
    tiers: DepositTier[];
    hoursRemaining?: number;
    hideActions?: boolean;
}

const DepositBonusPopup: React.FC<DepositBonusPopupProps> = ({
    open,
    onClose,
    onFundNow,
    tiers,
    hoursRemaining,
    hideActions
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    background: 'linear-gradient(180deg, #23242C 0%, #17181D 100%)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    borderRadius: '30px',
                    width: '480px',
                    maxWidth: '90vw',
                    padding: '28px 24px',
                    position: 'relative',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                },
            }}
        >
            <IconButton onClick={onClose} sx={{ position: 'absolute', top: '16px', right: '16px', color: '#B0B3B8' }}>
                <CloseIcon />
            </IconButton>

            <Box display="flex" justifyContent="center" alignItems="center" gap="8px" mb={3}>
                <img src={wolfpackLogo} alt="Wolfpack" style={{ height: '24px', width: 'auto' }} />
            </Box>

            <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '32px', textAlign: 'center', lineHeight: 1.15, mb: 1 }}>
                Earn More{' '}
                <Box component="span" sx={{ background: 'linear-gradient(90deg, #F2674A 0%, #FFA347 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                    Spins
                </Box>
            </Typography>

            <Typography sx={{ color: '#9A9CA5', fontSize: '15px', textAlign: 'center', mb: 3 }}>
                Fund your account now to unlock more spins
            </Typography>

            <Box display="flex" justifyContent="center" mb={3}>
                <img src={depositBonusImg} alt="Deposit bonus" style={{ width: '260px', height: 'auto' }} />
            </Box>

            <Box display="flex" flexDirection="column" gap="10px" mb={2}>
                {tiers.map((tier) => (
                    <Box
                        key={tier.minAmount}
                        sx={{
                            border: '1px solid rgba(255,255,255,0.12)',
                            borderRadius: '50px',
                            py: '10px',
                            px: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box display="flex" alignItems="center" gap="10px">
                            <img src={coinIcon} alt="Coin" style={{ width: '40px', height: '40px' }} />
                            {/* <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #FFD166 0%, #F2674A 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontWeight: 800,
                                    fontSize: '14px',
                                    flexShrink: 0,
                                }}
                            >
                                $
                            </Box> */}
                            <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '20px' }}>
                                ${tier.minAmount}+
                            </Typography>
                        </Box>

                        <Typography sx={{ color: '#F2674A', fontSize: '16px' }}>&rarr;</Typography>

                        <Box display="flex" alignItems="center" gap="8px">
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    backgroundColor: '#2A2B33',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#FFC24B',
                                    fontSize: '15px',
                                    flexShrink: 0,
                                }}
                            >
                                ★
                            </Box>
                            <Typography sx={{ color: 'white', fontSize: '15px' }}>
                                Get <Box component="span" sx={{ color: '#F2674A', fontWeight: 800 }}>{tier.spinCount}</Box>{' '}
                                {tier.spinCount === 1 ? 'Spin' : 'Spins'}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>

            <Typography sx={{ color: '#9A9CA5', fontSize: '12px', textAlign: 'center', mb: 3, lineHeight: 1.5 }}>
                Exclusive to first deposit only. Must be redeemed within{' '}
                <Box component="span" sx={{ color: '#FFC24B', fontWeight: 700 }}>
                    {hoursRemaining ?? 72} hours
                </Box>{' '}
                of verified trading account.
            </Typography>

            {!hideActions && (
                <>
                    <Box
                        onClick={onFundNow}
                        sx={{
                            background: 'linear-gradient(90deg, #F2674A 0%, #FFA347 100%)',
                            borderRadius: '50px',
                            py: '14px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            mb: 2,
                            transition: 'filter 0.2s',
                            '&:hover': { filter: 'brightness(0.95)' },
                        }}
                    >
                        <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '16px' }}>Fund & Trade Now</Typography>
                    </Box>

                    <Typography
                        onClick={onClose}
                        sx={{ color: '#9A9CA5', fontSize: '14px', textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', mb: 2, '&:hover': { color: 'white' } }}
                    >
                        Maybe Later
                    </Typography>
                </>
            )}
            <Box
                sx={{
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: '16px',
                    p: '12px 14px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                }}
            >
                <Box
                    sx={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: '#F2674A',
                        color: 'white',
                        fontSize: '12px',
                        fontWeight: 800,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        mt: '2px',
                    }}
                >
                    i
                </Box>
                <Typography sx={{ color: '#9A9CA5', fontSize: '11px', lineHeight: 1.5 }}>
                    First deposit only. Qualifying funding must be completed within{' '}
                    <Box component="span" sx={{ color: '#FFC24B', fontWeight: 700 }}>
                        {hoursRemaining ?? 72} hours
                    </Box>{' '}
                    of Trading Account approval. Terms and Conditions apply.
                </Typography>
            </Box>
        </Dialog>
    );
};

export default DepositBonusPopup;